import React, { useRef, useState } from 'react'
import { message } from 'antd'
import Button from 'meinian-package/src/baseComponent/button'
import { Ul, Li, Dropdown } from 'meinian-package/src/baseComponent'
import util from 'meinian-package/src/utils/util'
import Icon from 'meinian-package/src/component/icon'
import ModalConfirm from 'meinian-package/src/component/modal/modalConfirm'
import request from 'meinian-package/src/utils/request'
import Collect from 'meinian-package/src/component/collect'
import { MARK_STATUS, getMarkStatusText } from 'meinian-package/src/component/enum'
import { isPermissions, teamHasAuth } from 'meinian-package/src/utils/auth'
import { renderMoveImage } from 'meinian-package/src/component/useFunModal/moveImage'
import SampleModal from 'component/imageDetail/sampleModal'
import { setSampleComplete } from 'component/imageDetail/sampleModal/common'
import { useRequest } from 'ahooks'
import ExportStyle from 'component/imageAction/exportStyle'
import { PLATFORM_VALUE, ZK_PLATFORM_VALUE } from 'meinian-package/src/component/platformConfig'
import Examine from '../../../../../../component/imageAction/examine'
import RejectComment from '../../../../../../component/imageAction/examine/rejectComment'
import noteRemind from '../../../../../../component/useFunModal/noteRemind'
import { MoreBtn } from '../../../../../../component/waterfall.card/action'
import PrintImage from '../../../../../../component/imageAction/printImage'
import Upgrade from '../../../../../../component/imageAction/edit'
import imageDetailForceGuide, { GUIDE_KEYS } from '../../../forceGuideConfig'
import styles from './index.module.less'

export default ({
  currentImage,
  imgInfoList,
  onInit,
  hasZkOfficialStyle,
  setQuickEditVisible,
  onChange,
  queryParams,
  setBanOperation,
  initWaterfall,
  onVisibleChange,
  boxIndex,
  onDeleteItem,
  onInitCommentTotal,
  runImgsData
}) => {
  const {
    markStatus,
    loginUserInfo,
    imageGroupEntityId,
    collectId,
    blogComment,
    userName,
    needMarkTimes,
    markTimes,
    platformId
  } = currentImage || {}
  const auth = loginUserInfo?.inspirationPermissions || []
  const { inspirationId } = queryParams || {}
  const addSampleInfo = [{ inspirationId, blogId: imageGroupEntityId, platformId, collectId }]
  const rejectCommentRef = useRef(null)
  const domRef = useRef(null)
  imageDetailForceGuide.useEmit(GUIDE_KEYS.STEP_1, domRef, currentImage)
  const [sampleModalVisible, setSampleModalVisible] = useState()

  const { data: hasMarker } = useRequest(() => request.get('/zhikuan/ins/inspiration/query-is-exist-marker', { params: { inspirationId } }))
  const _onChange = (success, newItemData) => {
    onChange?.(success, {
      imageGroupEntityId: currentImage.imageGroupEntityId,
      inspirationId: currentImage.inspirationId,
      ...newItemData
    })
    onInit()
  }

  const onDelete = () => {
    setBanOperation(true)
    ModalConfirm.show({
      title: '确定要删除该款式吗？',
      content: '当款式被删除后，该款式将从当前灵感集中移除，相关的信息也将一并删除',
      onOk: async () => {
        await request.post('/ins/inspiration/remove-from-inspiration', {
          blogList: [{ blogId: imageGroupEntityId }],
          inspirationId
        })
        message.success('已成功删除')
        onVisibleChange(false)
        onDeleteItem()
        setBanOperation(false)
      },
      onCancel: () => {
        setBanOperation(false)
      }
    })
  }

  const renderExamine = () => {
    if (hasMarker) {
      if (currentImage.hasMarkPermissions) {
        return <Examine
          onInitiativeBehavior={(val) => {
            rejectCommentRef.current?.onInitiativeBehavior(val)
          }}
          onCommentVisible={(val) => {
            rejectCommentRef.current?.onCommentVisible(val)
          }}
          hiddenSample
          hiddenDetailDelete
          trackSourceType
          isRecallOperation={false}
          className="owner-examine"
          currentBlog={currentImage}
          onChange={(_markStatus, _markTimes) => {
            _onChange?.(true, { markTimes: _markTimes, markStatus: _markStatus })
          }}
          wrapperClassName="image-detail-examine"
          type="detail"
        />
      } if ((markStatus === MARK_STATUS.UNSET && isPermissions(auth, ['FS07', 'FS07_CREATOR', 'FCS08', 'FCS08_CREATOR']))) {
        return <Examine.Commit
          className="meinian-button ghost"
          currentBlog={currentImage}
          onChange={(_markStatus, _markTimes) => {
            _onChange?.(true, { markTimes: _markTimes, markStatus: _markStatus })
          }}
        >提交审核
        </Examine.Commit>
      }
      return null
    }
    return null
  }
  const renderDetailText = () => {
    if (auth.includes('FCS07') || auth.includes('FS06')) {
      return <Examine.DetailText
        loginUserInfo={loginUserInfo}
        showIcon
        currentBlog={currentImage}
        className="examine-text"
        onChange={(_markStatus, _markTimes) => {
          _onChange?.(true, { markTimes: _markTimes, markStatus: _markStatus })
        }}
        auth={auth}
      />
    }
    return null
  }
  const renderVote = () => {
    return <Examine.Vote runImgsData={runImgsData} onInitCommentTotal={onInitCommentTotal} currentBlog={currentImage} className="meinian-button ghost" style={{ width: 60, maxWidth: 60, padding: '4px 8px', whiteSpace: 'nowrap' }} />
  }
  const renderMarkStatus = () => {
    if ((markStatus === MARK_STATUS.PENDING && !currentImage.hasMarkPermissions && isPermissions(auth, ['FS07', 'FS07_CREATOR', 'FCS08', 'FCS08_CREATOR']))) {
      return <div className="meinian-examine-commit-button-recall-detail">
        {isPermissions(auth, ['FS18_CREATOR']) && <Button
          type="normal"
          style={{ marginRight: '8px' }}
          onClick={(e) => {
            e.stopPropagation()
            noteRemind({
              option: {
                userName,
                collectId,
                inspirationId,
              },
            })
          }}
        >
          短信提醒
        </Button>}
        <Examine.Recall
          className="meinian-button ghost"
          currentBlog={currentImage}
          onChange={(_markStatus, _markTimes) => {
            _onChange?.(true, { markTimes: _markTimes, markStatus: _markStatus })
          }}
        />
      </div>
    }
    return null
  }
  const renderDelete = () => {
    if ((markStatus === MARK_STATUS.NOT_PASS && !currentImage.hasMarkPermissions && isPermissions(auth, ['FS04', 'FS04_CREATOR', 'FCS04', 'FCS04_CREATOR']))) {
      return <>
        <Button type="normal" onClick={onDelete} style={{ marginRight: '8px' }}>删除</Button>
        {
        !!blogComment.length && <Examine.LeaveComment
          style={{ marginRight: '8px' }}
          onClick={(e) => {
            e.stopPropagation()
            rejectCommentRef.current?.onInitiativeBehavior(true)
            rejectCommentRef.current?.onCommentVisible?.(pre => !pre)
          }}
        />
      }
      </>
    }
    return null
  }
  const renderSample = () => {
    if (isPermissions(auth, ['FS13', 'FCS14']) && teamHasAuth('meinian_sample_clothing') && getMarkStatusText(markStatus, { isPass: true, maxLevel: needMarkTimes, level: markTimes })) {
      const onOkSampleModal = async (processId, option) => {
        addSampleInfo[0].processId = processId
        await setSampleComplete([{ ...addSampleInfo[0], ...option }], () => setSampleModalVisible(false))
        setBanOperation(false)
        onInit()
      }
      return <span onClick={() => {
        if (markStatus !== MARK_STATUS.PASS) {
          currentImage.hasMarkPermissions ? message.info('升级样衣前，请先确保款式被审核通过哟。点击左侧的审核通过按钮，即可将款式审核通过~~')
            : message.info('升级样衣前，请先确保款式被审核通过哟，请联系灵感集的审核者来完成款式审核吧。如有疑问，请联系客服~~')
        }
      }}
      >
        <Button
          type="primary"
          style={{ height: 32, marginRight: 8, display: markStatus !== MARK_STATUS.PASS && 'none' }}
          onClick={() => {
            setSampleModalVisible(true)
            setBanOperation(true)
          }}
          disabled={markStatus !== MARK_STATUS.PASS}
        >设为样衣</Button>
        {sampleModalVisible && <SampleModal
          authList={auth}
          onClose={() => {
            setSampleModalVisible(false)
            setBanOperation(false)
          }}
          visible={sampleModalVisible}
          onOk={onOkSampleModal}
        />}
      </span>
    }
    return null
  }

  const renderMore = () => {
    if (isPermissions(auth, ['FCS07', 'FS06'])) {
      return <MoreOperation
        setBanOperation={setBanOperation}
        onVisibleChange={onVisibleChange}
        initWaterfall={initWaterfall}
        boxIndex={boxIndex}
        currentImage={currentImage}
        imgInfoList={imgInfoList}
        setQuickEditVisible={setQuickEditVisible}
        queryParams={queryParams}
        onChange={_onChange}
        onDeleteItem={onDeleteItem}
        onDelete={onDelete}
      />
    }
    return <div className="only-collect">
      <Collect
        hasCurInstated
        currentBlog={{ ...currentImage }}
        className="button"
      >
        <Button other style={{ width: 88 }}>采集</Button>
      </Collect>
    </div>
  }

  return <div className={styles.infoBlockFooter}>
    <RejectComment
      ref={rejectCommentRef}
      rejectWindowClassName="image-detail-reject-comment-window"
      markStatus={markStatus}
      loginUserInfo={loginUserInfo}
      key={collectId}
      messageData={{
        userId: currentImage?.userId,
        inspirationId,
        blogId: imageGroupEntityId,
        collectOrSampleId: collectId,
        blogComment,
        type: 0
      }}
    />
    {
      !hasZkOfficialStyle ? <div className={styles['style-detail-button']} ref={domRef}>
        {renderDetailText()}
        {renderVote()}
        {renderExamine()}
        {renderMarkStatus()}
        {renderDelete()}
        {renderSample()}
        {renderMore()}
      </div> : <div className={styles['style-detail-button']} ref={domRef}>
        <div className="only-collect">
          <Collect
            hasCurInstated
            currentBlog={{ ...currentImage }}
            className="button"
          >
            <Button other style={{ width: 88 }}>采集</Button>
          </Collect>
        </div>
      </div>
    }
  </div>
}
const PLATFORM_HIDDEN_UPDATE = [
  PLATFORM_VALUE.BRAND, // 1. 品牌预售
  PLATFORM_VALUE.WHOLESALE, // 2. 批发市场 下架
  PLATFORM_VALUE.RETAIL, // 3. 零售市场 下架
  PLATFORM_VALUE.JP, // 4. 街拍
  PLATFORM_VALUE.DHH, // 5. 订货会
  PLATFORM_VALUE.INSGOODS, // 6. INS商品 下架
  PLATFORM_VALUE.WEIBO, // 7. 微博下架
  PLATFORM_VALUE.SHOW, // 8. 秀场
  PLATFORM_VALUE.UPLOAD, // 9. 上传灵感
  PLATFORM_VALUE.XIU_CHANGE_XI_JIE, // 10. 秀场细节
  PLATFORM_VALUE.SHI_ZHUANG_DA_PIAN, // 11. 时装大片
  PLATFORM_VALUE.CROSSBORDER_INS_GOODS, // 12. 海外探款-INS商品 下架
  PLATFORM_VALUE.CROSSBORDER_SHOW, // 13. 海外探款-秀场 下架
  PLATFORM_VALUE.COLLECT_PLUG, // 14. 采集插件
  PLATFORM_VALUE.FD_PLUS, // 15. FD+智能设计
  PLATFORM_VALUE.FD_MATERIAL, // 16. FD素材库
  ...Object.values(ZK_PLATFORM_VALUE) // 17. 知款站点（包含PORTER, FARFETCH, SSENSE, SHOPBOP, MUSINSA等）
]
const MoreOperation = (props) => {
  const {
    currentImage,
    onDelete,
    imgInfoList,
    setQuickEditVisible,
    queryParams,
    setBanOperation,
    onChange,
    onVisibleChange,
    boxIndex,
    onDeleteItem,
    initWaterfall,
  } = props
  const { imageGroupEntityId, loginUserInfo, platformId } = currentImage || {}
  const auth = loginUserInfo?.inspirationPermissions || []
  const [visible, setVisible] = useState(false)

  const renderEdit = () => {
    if (isPermissions(auth, ['FS05', 'FS05_CREATOR', 'FCS06', 'FCS06_CREATOR'])) {
      return <>
        <Upgrade
          currentImage={currentImage}
          setBanStatus={setBanOperation}
          inspirationId={queryParams.inspirationId}
          noAuth={!isPermissions(auth, ['FS05', 'FS05_CREATOR', 'FCS06', 'FCS06_CREATOR'])}
          blogId={queryParams.blogId}
          loginUserInfo={loginUserInfo}
          onDeleteItem={onDeleteItem}
          onChange={onChange}
          boxIndex={boxIndex}
        >
          <Li className="mn-dropdown-icon-li" onClick={() => setVisible(false)}><Icon type="m-bianji" />编辑</Li>
        </Upgrade>
        <Li
          className="mn-dropdown-icon-li"
          onClick={() => {
            setQuickEditVisible(true)
            setVisible(false)
          }}
        >
          <Icon type="m-kuaisubianji" />快速编辑
        </Li>
        <div className="li-partition" />
      </>
    }
  }

  const renderMove = () => {
    if (isPermissions(auth, ['FS04', 'FS04_CREATOR', 'FCS04', 'FCS04_CREATOR'])) {
      return <Li
        className="mn-dropdown-icon-li"
        onClick={() => {
          setBanOperation(true)
          renderMoveImage({
            blogId: imageGroupEntityId,
            blog: currentImage,
            fromInspirationId: queryParams.inspirationId,
            onChange: () => {
              onVisibleChange(false)
              initWaterfall()
              setBanOperation(false)
            },
            onCancel: () => {
              setBanOperation(false)
            }
          })
        }}
      ><Icon type="m-yidong" onClick={() => setVisible(false)} />移动</Li>
    }
  }
  const renderExportStyle = () => {
    if (isPermissions(auth, ['FCS07', 'FS06'])) {
      return <ExportStyle
        id={queryParams.collectId}
        fileName={currentImage?.inspirationName || '款式'}
        onChange={() => {
          util.track('mn-statement-export', {
            module1: '单款导出',
            module2: '款式详情导出'
          })
        }}
      >
        <Li className="mn-dropdown-icon-li" onClick={() => setVisible(false)}><Icon type="m-daochu" />导出</Li>
      </ExportStyle>
    }
  }

  const renderPrintImage = () => {
    if (isPermissions(auth, ['FS14', 'FCS15'])) {
      return <PrintImage
        imageInfo={imgInfoList}
        upgradeInfo={currentImage}
        unionId={props.unionId}
        blogId={imageGroupEntityId}
        inspirationId={queryParams.inspirationId}
        platformId={props.platformId}
      >
        <div onClick={() => setVisible(false)}>
          <Li className="mn-dropdown-icon-li" onClick={() => { request.track({ code: 6400034, type: '款式详情-打印' }) }}><Icon type="m-dayin" />打印</Li>
        </div>
      </PrintImage>
    }
  }

  const renderEditStyleReceipts = () => {
    if (isPermissions(auth, ['FS11', 'FCS12']) && teamHasAuth('meinian_style_receipts')) {
      return <>
        <div className="li-partition" />
        <Li className="mn-dropdown-icon-li">{currentImage.markStatus === MARK_STATUS.PASS ? <div
          onClick={() => {
            setVisible(false)
            window.open(`/meinian/editProcess?collectId=${queryParams.collectId}&imageGroupEntityId=${imageGroupEntityId}&inspirationId=${queryParams.inspirationId}&blogId=${queryParams.blogId}&unionId=${props?.unionId}&platformId=${props?.platformId}`, '_blank')
          }}
        ><Icon type="m-bianji" />编辑制版单</div> : <div onClick={() => message.error('当前款式未审核通过，不可编辑制版单哦-_-')}><Icon type="m-bianji" />编辑制版单</div>}</Li>
      </>
    }
  }

  const renderExportStyleReceipts = () => {
    if (isPermissions(auth, ['FS12', 'FCS13']) && teamHasAuth('meinian_style_receipts')) {
      return <Li className="mn-dropdown-icon-li">
        <div
          onClick={async () => {
            if (currentImage.markStatus === MARK_STATUS.PASS) {
              setVisible(false)
              try {
                await request.downloadBlob(`/api/zhikuan/style-receipts/export?blogId=${imageGroupEntityId}&inspirationId=${queryParams.inspirationId}`, `制版单_${currentImage?.inspirationName || '款式'}.xlsx`, false)
              } catch (error) {
                message.error('下载失败，请重试')
              }
            } else {
              message.error('当前款式未审核通过，不可生成制版单哦-_-')
            }
          }}
        >
          <Icon type="m-xiazai" />下载制版单
        </div>
      </Li>
    }
  }
  const renderUpdateData = () => {
    return <Li className="mn-dropdown-icon-li">
      <div
        onClick={async () => {
          try {
            const res = await request.get('/zhikuan/ins/inspiration/blog-detail-update', { params: { blogId: imageGroupEntityId, platformId } })
            if (res) {
              setTimeout(() => {
                location.reload()
              }, 1000)
            }
          } catch (error) {
            console.error(error)
          }
        }}
      ><Icon type="m-shuaxin" />更新数据</div>
    </Li>
  }

  return <Dropdown
    trigger="hover"
    visible={visible}
    onVisibleChange={vis => setVisible(vis)}
    placement="bottomRight"
    overlay={<Ul style={{ width: 145 }}>
      {renderEdit()}
      <Collect hasCurInstated currentBlog={{ ...currentImage }} className="button">
        <Li className="mn-dropdown-icon-li" onClick={() => setVisible(false)}><Icon type="m-caiji" />采集</Li>
      </Collect>
      {renderMove()}
      {renderExportStyle()}
      {renderPrintImage()}
      {renderEditStyleReceipts()}
      {renderExportStyleReceipts()}
      <div className="li-partition" />
      {!PLATFORM_HIDDEN_UPDATE.includes(platformId) && renderUpdateData()}
      {isPermissions(auth, ['FS04', 'FS04_CREATOR', 'FCS04', 'FCS04_CREATOR']) ? <Li className="mn-dropdown-icon-li delete" onClick={onDelete}><Icon type="m-shanchu" />删除</Li> : null}
    </Ul>}
  >
    <MoreBtn style={{ cursor: 'pointer' }} />
  </Dropdown>
}
